<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    @import '~bootstrap-vue/dist/bootstrap-vue.css';
    @import 'assets/scss/style';
</style>
